module.exports = __webpack_public_path__ + "19d1bd9e3f4a5d86806b15e89050630f.svg";